import * as React from 'react';

import { Button } from 'react-aria-components';

import { cn } from '@avodah-inc/ui/utils';

import type { PatientCardInfo } from '../../atoms';
import { PatientDataCard, Typography } from '../../atoms';

export type UploadHistoryProps = React.HTMLAttributes<HTMLDivElement> & {
  patientData: PatientCardInfo[];
};

export const UploadHistory = React.forwardRef<
  HTMLDivElement,
  UploadHistoryProps
>(({ patientData }, ref) => {
  const [isHistoryHidden, setHistoryHidden] = React.useState(false);
  return (
    <div className="flex w-full flex-col" ref={ref}>
      <Button
        onPress={() => {
          setHistoryHidden((prev) => !prev);
        }}
        className="focus:outline-none active:outline-none"
      >
        <Typography className="text-primary-500" variant="h4">
          {isHistoryHidden ? 'Show upload history' : 'Hide upload history'}
        </Typography>
      </Button>
      <div
        className={cn('grid overflow-hidden transition-[grid-template-rows]', {
          'grid-rows-[1fr]': !isHistoryHidden,
          'grid-rows-[0fr]': isHistoryHidden,
        })}
      >
        <div className="min-h-0">
          {patientData.map((data) => (
            <PatientDataCard
              patientCardInfo={{
                isHistoryView: true,
                fileName: data.fileName,
                fileSize: data.fileSize,
                uploadedBy: data.uploadedBy,
                uploadedDateTime: data.uploadedDateTime,
                onDownloadClicked: data.onDownloadClicked,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
});

UploadHistory.displayName = 'UploadHistory';
